import { create } from 'zustand';

type FaqStore = {
  closeFaq: () => void;
  openFaq: () => void;
  showFaq: boolean;
};

const useFaqStore = create<FaqStore>(set => ({
  closeFaq: () => set({ showFaq: false }),
  openFaq: () => set({ showFaq: true }),
  showFaq: false
}));

export function useFaq() {
  return useFaqStore();
}
